import { parseBooleanFilterValue } from '@sib/api/utils';

export const mapSelectValueToBoolean = (value: string): boolean | null =>
  parseBooleanFilterValue(value);

export const mapBooleanToSelectValue = (value: boolean | null): string => {
  if (value == null) return '';

  return String(value);
};
